var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgStreamlineIconEmailActionUnread = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 24 24"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M23.89 5.83a.18.18 0 0 0-.2 0l-9.75 9.75a2.72 2.72 0 0 1-1.94.8 2.8 2.8 0 0 1-1.95-.8L.31 5.87a.18.18 0 0 0-.2 0A.18.18 0 0 0 0 6v12a2 2 0 0 0 2 2h20a2 2 0 0 0 2-2V6a.18.18 0 0 0-.11-.17"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  d: "M11.11 14.56a1.27 1.27 0 0 0 1.77 0l9.69-9.69a.5.5 0 0 0 .12-.51C22.58 4 22.27 4 22 4H2c-.28 0-.58 0-.69.36a.5.5 0 0 0 .12.51Z"
})));
export default SvgStreamlineIconEmailActionUnread;